let ipcRenderer: any = null;
if (window && window.require) {
    ipcRenderer = window.require("electron").ipcRenderer;
}
/**
 * 打开应用窗口
 * @param appCode 应用标识码/窗口标识
 * @param url 应用URL
 */
export let openWin = (appCode: string, url: string) => {
    if (ipcRenderer) {
        ipcRenderer.send("create-app-win", appCode, url);
    } else {
        window.open(url, appCode)
    }

};
/**
 * 关闭应用窗口
 * @param appCode 应用标识码/窗口标识
 */
export let closeWin = (appCode: string) => {
    if (ipcRenderer) {
        ipcRenderer.send("close-app-win", appCode);
    }
};
/**
 * 显示应用个窗口
 * @param appCode 应用标识码/窗口标识
 */
export let showWin = (appCode: string) => {
    if (ipcRenderer)
        ipcRenderer.send("show-app-win", appCode);
};
/**
 * 加载应用窗口
 * @param appCode 应用表示/窗口标识
 * @param url 应用URL
 */
export let loadWin = (appCode: string, url: string) => {
    if (ipcRenderer)
        ipcRenderer.send("load-app", appCode, url);
};